import React, { useState, useEffect } from 'react';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { useLanguage } from '../contexts/LanguageContext';
import { supabase } from '../supabase';
import { v4 as uuidv4 } from 'uuid';
import '../styles/TextUpload.css';
import { Check, Save } from 'lucide-react';

function TextUpload({ title }) {
  const { authUserId, selectedWorkspaceId } = useWorkspace();
  const { language } = useLanguage();
  const [text, setText] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (title) {
      setText(``);
    }
  }, [title]);

  const handleSubmit = async () => {
    if (!title || !text) {
      setError('Both title and answer are required!');
      return;
    }

    if (!authUserId || !selectedWorkspaceId) {
      setError('Invalid session: missing user or workspace.');
      return;
    }

    setError('');
    setSuccessMessage('');

    const timestamp = new Date().toISOString();
    const documentId = uuidv4();

    const documentData = {
      id: documentId,
      name: title,
      created_at: timestamp,
      updated_at: timestamp,
      updated_by: authUserId,
      workspace_id: selectedWorkspaceId,
      folder_path: "input/",
      type: 'text/plain/note',
      content: text,
    };

    try {
      const { error: insertError } = await supabase.from('documents').insert([documentData]);

      if (insertError) {
        throw insertError;
      }

      setSuccessMessage('Answer uploaded successfully!');
      setText('');
    } catch (err) {
      setError(`Upload failed: ${err.message}`);
    }
  };

  return (
    <div className="text-upload-container">
      <div className="text-upload-box">
        <label className="upload-label">{language === 'en' ? 'Answer' : 'Antwort'}</label>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={language === 'en' ? 'Please enter your answer here' : 'Bitte geben Sie hier Ihre Antwort ein'}
          className="text-area"
        ></textarea>
      </div>

      {error && <p className="upload-error-text">{error}</p>}
      {successMessage && <p className="upload-success-text">{successMessage}</p>}

      <button className="upload-submit-button" onClick={handleSubmit}>
        <Save size={14} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
        {language === 'en' ? 'Save' : 'Speichern'}
      </button>
    </div>
  );
}

export default TextUpload;
